import { Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';
import { EcaadminDashboardService } from '../ecaadmin-dashboard.service';

@Component({
  selector: 'app-ecasub-admins',
  templateUrl: './ecasub-admins.component.html',
  styleUrls: ['./ecasub-admins.component.css']
})
export class EcasubAdminsComponent implements OnInit {
  @ViewChildren("checkboxes") checkboxes: QueryList<ElementRef>;

  subAdminList: any[];
  selectedSubAdmin;
  selectedSubAdminId;
  sessionList: any[];
  selectedSessionArray: any[] = [];

  constructor(
    private adminDashboardService:  EcaadminDashboardService
  ) { }

  ngOnInit(): void {
    this.getSubAdminList();
  }

  getSubAdminList(){
    this.adminDashboardService.userList({userType:'SUBADMIN'}).subscribe((dataResult: any)=>{
      console.log("subadmin list",dataResult);
      this.subAdminList = dataResult.list;
      console.log(this.subAdminList);
      this.selectedSubAdmin = this.subAdminList[0];
    })
  }

  onSubAdminDetails(subAdminId: string) {
    console.log(subAdminId);
    for (let subAdmin of this.subAdminList) {
      if (subAdmin._id == subAdminId) {
        this.selectedSubAdmin = subAdmin;
      }
    }
    console.log(this.selectedSubAdmin);
  }

  onDeleteSubAdmin(userId:string){
    console.log("delete id",userId);
    this.adminDashboardService.deleteUser({userId:userId}).subscribe((dataResult:any)=>{
      this.getSubAdminList();
    })
  }

  // getSessionList(){
  //   console.log("hit session list");
  //   this.adminDashboardService.sessionList().subscribe((dataResult: any)=>{
  //     console.log("session list",dataResult);
  //     this.sessionList = dataResult.list;
  //     console.log(this.sessionList);
  //   })
  // }

  // onChecked(sessionId) {
  //   console.log(sessionId);
  // }

  onChecked(sessionId: string) {
    let i = 0;

    for (let session of this.selectedSessionArray) {
      if (session == sessionId) {
          i = i+1;
          break;
      }
    }
    if (i==1) {
      delete this.selectedSessionArray[this.selectedSessionArray.findIndex(session => session == sessionId)];
      this.selectedSessionArray = this.selectedSessionArray.filter(e => e != null);
      i = 0;
    } else {
      this.selectedSessionArray.push(sessionId);
      i = 0;
    }
  }

  onAllotSessions(subAdminId) {
    for (let subAdmin of this.subAdminList) {
      if (subAdmin._id == subAdminId) {
        this.selectedSubAdmin = subAdmin;
      }
    }
    console.log(this.selectedSubAdmin);

    this.adminDashboardService.SpecificUserSessionList({userId: subAdminId}).subscribe((dataResult: any) => {
      console.log("subadminsessionlist", dataResult);
      this.sessionList = dataResult.list;
    })
  }

  onSaveChanges() {
    console.log(this.selectedSubAdmin._id, this.selectedSessionArray);

    this.adminDashboardService.allotedSession({
      userId: this.selectedSubAdmin._id,
      sessionId: this.selectedSessionArray
    }).subscribe((dataResult: any) => {
     // console.log("sessionHit", dataResult);
      if(dataResult.success==true){
        console.log("successfully!");
        this.checkboxes.forEach((element) => {
          element.nativeElement.checked = false;
        });
        this.selectedSessionArray = [];
      }
      else {
        console.log("error found");
      }
    })
  }
}
